import styled from "styled-components";

import { SPACING } from "../../../utils/constants";

export const CardStack = styled.div`
  position: relative;
  width: 126px;
  height: 90px;
  margin-bottom: ${SPACING.xs}px;
`;

const GhostCard = styled.span`
  position: absolute;
  top: 8px;
  left: 50%;
  width: 78px;
  height: 56px;
  border-radius: ${SPACING.sm}px;
  background: var(--color-white);
  border: 1px solid var(--empty-state-border);
  box-shadow: var(--shadow-small);
`;

export const GhostCardBack = styled(GhostCard)`
  transform: translateX(-72%) rotate(-13deg);
`;

export const GhostCardMid = styled(GhostCard)`
  transform: translateX(-28%) rotate(13deg);
`;

export const BadgeSlot = styled.span`
  position: absolute;
  top: 4px;
  right: 8px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const FrontCard = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 86px;
  height: 60px;
  border-radius: ${SPACING.sm}px;
  background: var(--color-primary-color-background);
  box-shadow: var(--shadow-medium);
  transform: translate(-50%, -50%);
  overflow: hidden;

  & > svg {
    padding-top: ${SPACING.sm + SPACING.xs}px;
    color: var(--color-white);
    font-size: var(--text-display-lg);
  }
`;
